import logging from 'node-logging-js';
import jsb from 'node-jsb';

class Header {
    constructor(element, options) {
        logging.applyLogging(this, 'Header');
        this.logDebug('options:', options);
        this.element = element;

        this.menuBtn = this.element.querySelector('.js-menu-btn');
        this.menuWrap = this.element.querySelector('.js-menu-wrap');

        this.initializeEventListeners();
    }

    initializeEventListeners() {

        this.menuBtn.addEventListener('click', () => {
            this.element.classList.toggle('is-expanded');
        });

        window.addEventListener('load', () => {
            this.menuWrap.classList.add('is-loaded');
        });
    }
}

jsb.registerHandler('Header', Header);
export default Header;
